import { createContext, useContext } from 'react';
import { ILocale } from "./localize.service";

export interface IConfig {
	locale: {
		auth: {
			enterCRM?: string
		}
	},
	/**
	 *  Формат авторизации <br />
	 *  0 - текст (по умолчанию) <br />
	 *  1 - телефон <br />
	 *  2 - электронка
	 */
	loginFormat: 0 | 1 | 2,
	/**
	 * Текстовая информационная подпись под логином
	 */
	companyInfoAfterLoginLocated: string;
}


export type GlobalContext = {
	locale: ILocale;
	config: IConfig;
}

export const Context = createContext<GlobalContext>( {
	locale: "uk",
	config: {
		locale: {
			auth: {
				enterCRM: undefined
			}
		},
		loginFormat: 0,
		companyInfoAfterLoginLocated: ""
	}
} );

export const useGlobalContext = () => useContext( Context )

export default Context;
